module.exports = __webpack_public_path__ + "img/025.d5f0fef9.png";